import { jsx } from "react/jsx-runtime";
import { Children } from "react";
import AntTag from "antd/es/tag";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
import './Tag.css';/* empty css         */
const Tag = ({
  icon,
  color,
  backgroundColor,
  borderColor,
  iconHoverColor,
  borderHoverColor,
  style,
  className,
  children,
  iconColor = color,
  iconPosition = "right",
  closable = false,
  closeIcon = /* @__PURE__ */ jsx(Icon, { name: "cross", size: 10 }),
  ...props
}) => {
  const hasChildren = !!Children.count(children);
  if (!hasChildren && !icon) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    AntTag,
    {
      closable,
      icon: !!icon && /* @__PURE__ */ jsx("span", { className: classnames("perxis-auto-tag__icon"), children: icon }),
      closeIcon,
      style: {
        ...style,
        "--perxis-auto-tag-color": color,
        "--perxis-auto-tag-icon-color": iconColor,
        "--perxis-auto-tag-icon-hover-color": iconHoverColor,
        "--perxis-auto-tag-background-color": backgroundColor,
        "--perxis-auto-tag-border-color": borderColor,
        "--perxis-auto-tag-hover-border-color": borderHoverColor
      },
      className: classnames(
        [
          "perxis-auto-tag",
          `perxis-auto-tag--icon-position-${iconPosition}`,
          {
            [`perxis-auto-tag--icon-only`]: !children
          }
        ],
        className
      ),
      ...props,
      children: hasChildren && /* @__PURE__ */ jsx(Typography.Paragraph, { level: "marker", color: "lightest", children })
    }
  );
};
export {
  Tag as default
};
//# sourceMappingURL=Tag.js.map
